module.exports = __webpack_public_path__ + "781b498c3e92912aafe337b1a53cd76a.svg";